import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router';

import MapGridLayout from 'ff/debrief/layouts/MapGridLayout';
import HomeRoute, {
    pathString as homePath,
} from 'ff/debrief/router/routes/HomeRoute';
import DebriefRoute, {
    pathString as debriefPath,
} from 'ff/debrief/router/routes/DebriefRoute';
import SharedRoute, {
    pathString as sharedPath,
} from 'ff/debrief/router/routes/SharedRoute';
import SharedDebriefRoute, {
    pathString as sharedDebriefPath,
} from 'ff/debrief/router/routes/SharedDebriefRoute';

export const Router = () => {
    return (
        <BrowserRouter basename="/debrief">
            <Routes>
                <Route Component={MapGridLayout}>
                    <Route path={homePath} element={<HomeRoute />} />
                    <Route path={debriefPath} element={<DebriefRoute />} />
                    <Route path={sharedPath} element={<SharedRoute />} />
                    <Route
                        path={sharedDebriefPath}
                        element={<SharedDebriefRoute />}
                    />
                </Route>
            </Routes>
        </BrowserRouter>
    );
};
